// extracted by mini-css-extract-plugin
module.exports = {"PageLoader":"PageLoader_PageLoader__2ze8Q","Percent":"PageLoader_Percent__wPDmR"};